import type { Airflow } from '@aviata/platform-types';

export const getRoamingPrice = (
  productsList: Airflow.Order.Entity['products'],
) => {
  const roamingProducts = productsList.filter(
    // platform-types don't declare the roaming product type yet
    product => (product.type as string) === 'products.roaming',
  );

  if (roamingProducts.length === 0) {
    return null;
  }

  return roamingProducts.reduce(
    (acc, product) => acc + Number(product?.total),
    0,
  );
};
